import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { zxFlows } from '@/mocks/zhongxian-commerce';

export default function BusinessFlows() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="核心业务流程"
          subtitle="从供应商入驻、农产品溯源，到京客隆采购与履约、数字人民币红包、市场经营与食安召回，七条流程串起平台的完整经营闭环。"
        />

        <div className="mt-12 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {zxFlows.map((flow, idx) => (
            <Reveal key={flow.no} delay={Math.min(idx * 60, 360)}>
              <div className="h-full flex items-center gap-4 p-6 rounded-lg bg-background-100 border border-background-200 transition-colors hover:border-primary-300">
                <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 font-heading font-bold text-sm">
                  {flow.no}
                </span>
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${flow.icon} text-lg`}></i>
                </span>
                <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug">{flow.name}</h3>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 rounded-lg bg-background-100 border border-background-200 px-6 py-5 text-center">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 shrink-0">
              <i className="ri-eye-line"></i>
            </span>
            <p className="text-sm text-foreground-700 leading-relaxed">
              平台同时提供
              <span className="font-medium text-foreground-900">「六阶段业务流程」</span>
              和面向消费者的
              <span className="font-medium text-foreground-900">「种子到餐桌八阶段旅程」</span>
              两种展示视角，兼顾经营管控与消费透明。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}